import { useTranslation } from "react-i18next";
import React from "react";
import TldrSelect from "../common/TldrSelect";
import { AILanguages } from "../../_utils/constants";

const LanguageSelector = (props) => {
  const { i18n } = useTranslation();

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };
  return (
    !props.isCollapsed && (
      <TldrSelect
        options={AILanguages}
        onSelect={(output) => {
          changeLanguage(output.value);
        }}
      />
    )
  );
};

export default LanguageSelector;
